// extracted by mini-css-extract-plugin
export default {"table":"Parameters_table__ZJfsp","caption":"Parameters_caption__EzBbQ"};